import * as React from "react";
import Component from "../../AbstractComponent";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

export class BankAccountUpdate extends Component {
  private bankAccount: BankAccountInterface;

  public state = {
    accountId: "",
    name: "",
    label: "",
    isDefault: false
  };

  constructor(public props) {
    super(props);

    this.bankAccount = this.props.bankAccount;
  }

  public componentWillMount() {
    const state = {
      accountId: this.bankAccount?.accountId,
      name: this.bankAccount?.name,
      label: this.bankAccount?.label,
      isDefault: this.bankAccount?.isDefault
    };

    this.setState(state);
  }

  public onCancel = (): any => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose.call(this);
    }
  }

  public onSave = (): any => {
    if (typeof this.props.onSave === "function") {
      this.props.onSave.call(this, {
        id: this.bankAccount.id,
        accountId: this.state.accountId,
        name: this.state.name,
        label: this.state.label,
        isDefault: this.state.isDefault
      });
    }
  }

  public switchIsDefault = () => {
    this.setState({
      isDefault: !this.state.isDefault
    });
  }

  public render() {
    return (
      <div>
        <DialogContent>
          <TextField
            autoFocus={true}
            autoComplete="off"
            className="form-element full-size scroll-to-name"
            type="text"
            label={this.trans("dialog/bankaccount-field/label-label")}
            value={this.state.label}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "label")}
            variant="standard"
            error={!!this.getErrorFor("label")}
            helperText={this.getErrorFor("label")}
          />

          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-bankAccountId"
            type="text"
            label={this.trans("dialog/bankaccount-field/number-label")}
            value={this.state.accountId}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "accountId")}
            variant="standard"
            error={!!this.getErrorFor("bankAccountId") || !!this.getErrorFor("accountId")}
            helperText={!!this.getErrorFor("bankAccountId") ? this.getErrorFor("bankAccountId") : !!this.getErrorFor("accountId") ? this.getErrorFor("accountId") : ""}
          />

          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-name"
            type="text"
            label={this.trans("dialog/bankaccount-field/name-label")}
            value={this.state.name}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "name")}
            variant="standard"
            error={!!this.getErrorFor("name")}
            helperText={this.getErrorFor("name")}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.isDefault}
                style={{margin: "20px 0"}}
                onChange={this.switchIsDefault}
                color="primary"
              />
            }
            label={this.trans("dialog/bankaccount-checkbox/default")}
          />
        </DialogContent>
        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancel}
              style={{marginRight: "10px"}}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
            >
              {this.trans("dialog-button/save")}
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}
